/*! Author: Rohit Ghadigaonkar | Version: 8.1 [31d18y/l6.1] */

var slider,slider1,$slider,$slider1,
		$slider2,$slider3,$slider4,
		option = "",LastDrape = "All",count=0,
		obj=null,Contrast=false,zoom=false,
		lenszoom=false,product,productid,
		mono=true,key,serviceUrl,autoThread,
		autoSpecific,imageSize,autoAlignment,Fab=false;
$(window).resize(function() {
	//alert($(window).width());
	// if($(window).width()<1050 && )
	// {
		//alert("reload");
		// SliderReload();
		// location.reload();
	// }

});
function toTitleCase(str)
{
		return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}
$(document).ready(function() {


console.info("Textronic Version: 3.1 [02d19y/l8.1]");
//product="Men-Mens Shirt";
$slider = $('.slider8');
$slider1 = $('.slider9');
$slider2 = $('.slider10');
$slider3 = $('.slider11');
$slider4 = $('.slider12');



//$("#garments").css({"position":"absolute !important"});
			var op=null;
			var fp=null;
			if($(window).width()>1050)
			{
				op='#pfdd';
				fp='#pftdd';
			}
			else {
				op='#pfdd';
				fp='#pfdd2';
			}

			var url = $(location).attr('href'),
    		parts 	= url.split("/"),
    		last_part = parts[parts.length-1],
            p_name 	  = last_part.replace(/%20/g, " ");
  			var summaryProductName = '';
  
  			
  			if (p_name.includes('isabell'))
            {
              p_name = 'Women-Isabel Grey Lsskin';
              summaryProductName = 'Women Isabell Tailcoat';
            }
  			else if (p_name.includes('charlotte'))
            {
              p_name = 'Women-Charlotte';
              summaryProductName = 'Women Charlotte Short Jacket';
            }
  			else if (p_name.includes('catherine'))
            {
              p_name = 'Women-Catherine';
              summaryProductName = 'Women Catherine short Tailcoat';
            }
  			else if (p_name.includes('lottie'))
            {
              p_name = 'Women-Lottie';
              summaryProductName = '';
            }
  			else if (p_name.includes('rosie'))
            {
              p_name = 'Women-Rosie';
              summaryProductName = '';
            }
  			else if (p_name.includes('amanda'))
            {
              p_name = 'Women-Amanda';
              summaryProductName = '';
            }
  			else if (p_name.includes('gina'))
            {
              p_name = 'Women-Gina';
              summaryProductName = 'Women Gina cut-away short Jacket';
            }
  			else if (p_name.includes('carl'))
            {
              p_name = 'Men-Carl Navy Royal Men';
              summaryProductName = 'Men Carl Tailcoat';
            }
  			else if (p_name.includes('cameron'))
            {
              p_name = 'Men-Cameron';
              summaryProductName = 'Men Cameron short Jacket';
            }
  			else if (p_name.includes('victoria'))
            {
              p_name = 'Women-Victoria';
              summaryProductName = 'Women Victoria Tailcoat';
            }
  
// 	$.ajax({
// 		url:"Code/mylook.php?login",
// 		type:"POST",
// 		dataType : "json"
// 		}).done(function(r){

			//console.log(r);
			serviceUrl = 'https://flyc.textronic.online';
			key = '1171279046';
			autoSpecific = true;
			imageSize ="500";
			autoAlignment = true;
			product = p_name.replace('#','');
			autoThread = false;
			if(sessionStorage.getItem("product")!=null && sessionStorage.getItem("name")!=null)
			{
				product=sessionStorage.getItem("product");
				mono = true;
				$('#ptgdd li ul li').each(function(){
					//console.log($(this).attr('id'))
					if($(this).attr('id').toLowerCase() == product.toLowerCase()){
						$(this).addClass('active');
					}else{
						$(this).removeClass('active');
					}
				});
				sessionStorage.removeItem("product");
			}

			GetAllDropDown();

		obj = $("#pddd").tailori(
		{
			'Product':product,   //Product i.e men shirt,women shirt, men suit, etc
			'ProductTemplate':'#ProductTemplate',//Tempalte id for Product
			'ServiceUrl':serviceUrl,
			'ImageSource':'#garments', //Container Id for place inages
			'AutoSpecific':autoSpecific, //Auto specific view after selecting any feature
			'AutoAlignment':autoAlignment, //Auto alignment set according to selected element
			'AutoThread' : autoThread,
			'Monogram':true, //If monogram
			'ImageSize' :imageSize,
			'Key' : key,
			//'AutoThread' : false,
			'ImageFormat' : 'png',
			'MonogramTemplate':'#MonogramTemplate', //Tempalte id for Monogram UI
			'MonogramPlace':'#monosublist', // html containter for Monogram
			'FeatureTemplate':'#FeaturesTemplate',//Features Tempalte Id
			'FeaturesPlace':fp,//html Container for Features
			'OptionTemplate':'#optionsTemplate',//Option Template Id
			'OptionsPlace':op,//html containter for Options
			'OnProductChange': function(productName){
				$(".loder").show();

				hideDiv("color_sub_menu");
				hideDiv("fabric_sub_menu");
				hideDiv("monogram_sub_menu");
				if($(".menu").hasClass("show-nav")){
					$(".menu").removeClass("show-nav");
				}
				if(mono && obj.Monogram() != null){
					$("#pddd").append("<li id='Monogram'><a><span>Monogram</span></a></li>");
					mono=false;
				}
				else{
					$("#pddd #Monogram").remove();
				}
				if(productName.toLowerCase().includes("shirt") || productName.toLowerCase().includes("suit") 
					|| productName.toLowerCase().includes("bandhgala"))
				{
					
					$(".zoom_garments_c").show();
				}
				else {
					$(".zoom_garments_c").hide();
				}
				SliderReload();
				$("#specificView ul").empty();
				var data= obj.SpecificDetails();
				if(data.length > 0)
					$(".zoom_garments_c").show();
				for(var i in data) {
				$("#specificView ul").append("<li data-toggle='tooltip' title='"+data[i].Name+"' id='"+data[i].Id+"' style='background-image:url("+data[i].ImageSource+"); background-repeat:no-repeat;'></li>");
				}
				$("#specificView ul li").click(function(){
					$(".loder").show();
					obj.SpecificRender(this.id);
				});
				$('[data-toggle="tooltip"]').tooltip();
				$(".sel1").on('click','li',function(){
					//alert($(this).html());
					$(this).siblings().removeClass("monoselected");
					$(this).addClass("monoselected");
				});
				$(".color").on('click','li',function(){
					$(this).siblings().removeClass('active');
					$(this).addClass('active');
				 });
				$('#monogram-text').keyup(function(e) {
					var max = 14;
					if ($(this).val().length > max) {
						$(this).val($(this).val().substr(0, max));
					}
				});
				getc(0,$("#pddd li").eq(1).attr("data-tds-product"));
              //alert();
				$("#pddd li").eq(1).addClass("abc")
			},
			'IsOptionVisible':true,
			'OnRenderImageChange':function(imgurl){
				//setTimeout(function(){$("#pddd li").eq(1).addClass("abc")},1000);
				$("body .zoomContainer").remove();

				if($(window).width()>1050)
				{
					$("#garments #zoom").remove();
					$("#garments").append("<a href='#' id='zoom'><span class='zoom'></span><p>zoom</p></a>");
					lenszoom=false;
					$('#garments img:last').elevateZoom({
							zoomType: "lens",
							lensShape:"round",
							lensSize:300
						 });
					var aa=$('#garments img:last').data('elevateZoom');
			 		aa.changeState('disable');
				}
				var img=obj.Look()
				var url = img.Url;
				if(url.indexOf("type") > -1)
				{
					$(".zoom_garments_c").addClass("selected");
					$("#zoom").hide();
 				 	zoom=true;
				}
				$(".loder").hide();
				if(sessionStorage.getItem("product")!=null && sessionStorage.getItem("name")!=null)
				{
					product=sessionStorage.getItem("product");
					// setTimeout(function(){
						// obj.Product(sessionStorage.getItem("product"));
						// mono = true;
						// sessionStorage.removeItem("product");
					// },1050);
					obj.Product(sessionStorage.getItem("product"));
					mono = true;
					$('#ptgdd li ul li').each(function(){
						//console.log($(this).attr('id'))
						if($(this).attr('id').toLowerCase() == product.toLowerCase()){
							$(this).addClass('active');
						}else{
							$(this).removeClass('active');
						}
					});
					sessionStorage.removeItem("product");
				}else if(sessionStorage.getItem("name")!=null)
				{
					// setTimeout(function(){
						// obj.Look(sessionStorage.getItem("name"));
						// sessionStorage.removeItem("name");
					// },3000);
					$(".loder").show();
					obj.Look(sessionStorage.getItem("name"));
					sessionStorage.removeItem("name");
				}

			},
			'OnFeatureChange':function(featureid){

				getc(0,$("#pddd").find("li.abc").attr("data-tds-product"));
				$(".loder").show();
				$("#pftdd").find("[data-tds-element="+featureid+"]").siblings().find("a").removeClass("active");
				$("#pftdd").find("[data-tds-element="+featureid+"]").find("a").addClass("active");
				
				$("body").find("[data-tds-element="+featureid+"]").siblings().removeClass("active");
				$("body").find("[data-tds-element="+featureid+"]").addClass("active");
				
				$("#pftdd").find("[data-tds-element="+featureid+"]").siblings().find("span").css({
					"background-image": "",
					"padding-right" : "0px"
				});
				
				$("#pftdd").find("[data-tds-element="+featureid+"]").find("span").css({
					"background-image": "url(images/selected3.png)",
					"background-size": "11px",
					"background-repeat": "no-repeat",
					"background-position-x": "65px",
					"padding-right":"15%"
				});
				

			},
			'OnContrastChange':function(contrastid) {

				console.log(contrastid);
				if($(window).width()>1050)
				{
					if($(this).find('span').text().toLowerCase() != 'no contrast'){
						getc(1,productid);
						hideDiv("monogram_sub_menu");
						showDiv("fabric_sub_menu");
					}
				}
				else {
					if($(this).find('span').text().toLowerCase() != 'no contrast'){
						getc(2,productid);
						$(".menu3").addClass("show-nav");
					}
				}

			},
			'OnLibConfigChange':function(DetailId) {

				if($(window).width()>1050)
				{
					if($(this).find('span').text().toLowerCase() != 'no'){
						getc(3,DetailId,true);
						hideDiv("monogram_sub_menu");
						showDiv("fabric_sub_menu");
					}
				}
				else {
					if($(this).find('span').toLowerCase() != 'no'){
						getc(3,DetailId,true);
						$(".menu3").addClass("show-nav");
					}
				}

			},
			'OnOptionChange':function(optionname,featureid) {

				//alert(featureid);
				
				$(".menu").find("[data-tds-option="+optionname+"]").siblings().removeClass("active");
				$(".menu").find("[data-tds-option="+optionname+"]").addClass("active");
				$(".menu").find("[data-tds-option="+optionname+"]").siblings().find("span").css({
						"background-image": "",
						"padding-right" : "0px"
				});
				
				$(".menu").find("[data-tds-option="+optionname+"]").find("span").css({
					"background-image": "url(images/selected3.png)",
					"background-size": "11px",
					"background-repeat": "no-repeat",
					"background-position-x": "87%",
					"padding-right":"20%"
				});
					
				if($(window).width()>1050)
				{
					$(".sub_tital").html($(this).find('span').html());
					hideDiv("monogram_sub_menu");
					hideDiv("fabric_sub_menu");
					showDiv("color_sub_menu");
					
					$("#color_sub_menu").find("[data-tds-element="+featureid+"]").siblings().find("a").removeClass("active");
					$("#color_sub_menu").find("[data-tds-element="+featureid+"]").find("a").addClass("active");
					
					
				
				}
				else {
					$(".menu2").addClass("show-nav");
					$(".menu2").find("[data-tds-element="+featureid+"]").siblings().removeClass("active");
					$(".menu2").find("[data-tds-element="+featureid+"]").addClass("active");
				}

				$("#pftdd").find("[data-tds-element="+featureid+"]").siblings().find("span").css({
					"background-image": "",
					"padding-right" : "0px"
				});
				
				$("#pftdd").find("[data-tds-element="+featureid+"]").find("span").css({
					"background-image": "url(images/selected3.png)",
					"background-size": "11px",
					"background-repeat": "no-repeat",
					"background-position-x": "65px",
					"padding-right":"15%"
				});
					
			},
			'OnProductDetailChange':function(proid,optionId,featureid){

				if($(this).siblings().hasClass("abc")){
					$(this).siblings().removeClass("abc");
				}
				$(this).addClass("abc");
				productid=proid;
				
				
				var result=obj.Options(proid);
				var result1=obj.Contrasts(proid);
				if((result.length+result1.length) >1){
					hideDiv("color_sub_menu");
					hideDiv("monogram_sub_menu");
					$(".menu").addClass("show-nav");
					$(".menu").find("[data-tds-option="+optionId+"]").siblings().removeClass("active");
					$(".menu").find("[data-tds-option="+optionId+"]").addClass("active");
					
					$(".menu").find("[data-tds-option="+optionId+"]").siblings().find("span").css({
						"background-image": "",
						"padding-right" : "0px"
					});
					
					$(".menu").find("[data-tds-option="+optionId+"]").find("span").css({
						"background-image": "url(images/selected3.png)",
						"background-size": "11px",
						"background-repeat": "no-repeat",
						"background-position-x": "87%",
						"padding-right":"20%"
					});
				}
				else {
					if($(window).width()>1050){
					$(".sub_tital").html($(this).find('span').html());
					hideDiv("monogram_sub_menu");
					hideDiv("fabric_sub_menu");
					showDiv("color_sub_menu");
					$("#color_sub_menu").find("[data-tds-element="+featureid+"]").siblings().find("a").removeClass("active");
					$("#color_sub_menu").find("[data-tds-element="+featureid+"]").find("a").addClass("active");
					}
					else {
						$(".menu2").addClass("show-nav");
						$(".menu2").find("[data-tds-element="+featureid+"]").siblings().removeClass("active");
						$(".menu2").find("[data-tds-element="+featureid+"]").addClass("active");
					}
					
					$("#pftdd").find("[data-tds-element="+featureid+"]").siblings().find("span").css({
						"background-image": "",
						"padding-right" : "0px"
					});
					
					$("#pftdd").find("[data-tds-element="+featureid+"]").find("span").css({
						"background-image": "url(images/selected3.png)",
						"background-size": "11px",
						"background-repeat": "no-repeat",
						"background-position-x": "65px",
						"padding-right":"15%"
					});
				}
				
				

			},
			'OnMonogramChange' : function(){
				$(".loder").show();
			}
		 });
		 /* Plugin End */

// 		}).fail(function(jqXhr, textStatus, errorThrown) {
// 		 	 alert("Please Try Again");
// 	 	});
/************************** Get All Fabric ***********************************/
			//alert($("#pddd li").eq(1).attr("data-tds-product"));
		 //getc(0);
 /********************* Zomm Lens *****************************************/
		 $("#garments").on('click','#zoom',function(){

			 if(lenszoom==false || lenszoom==undefined)
			 {
				 lenszoom=true
			 }
			 else {
			 	lenszoom=false;
			 }

			 if(lenszoom==true)
			 {
				 //alert(lenszoom);
				 $("#zoom span").removeClass("zoom").addClass("zoomselected");
						var aa=$('#garments img:last').data('elevateZoom');
						aa.changeState('enable');
			 }
			 else {
			 	$("#zoom span").removeClass("zoomselected").addClass("zoom");
				var aa=$('#garments img:last').data('elevateZoom');
				aa.changeState('disable');
			 }
		 });
/********************* For Getting Summary ***********************************/
			 $(".summaryButton").click(function(){
				var productName = $("#Men .active").attr("id");
				$("#productName").empty().html("<h3>"+summaryProductName.toUpperCase()+"</h3>");
				var txt="<table class='table table-striped' style='width:110%'>";

				var result = obj.Summary();
				 //console.log(result);
				 //alert(result[0].length);
				 $("#summary-image").html("<img style='width:100%;height:auto' src='"+obj.Look('image')+"'>");
				 txt+="<tr><td colspan=4><center><b>Product Summary</b></center></td></tr>";
				 for(i=0;i<result.ProductSummary.length;i++)
				 {
					 	txt+="<tr><td>"+result.ProductSummary[i].Product+"</td><td>"+result.ProductSummary[i].Option+"</td><td>"
						+result.ProductSummary[i].Feature+"</td></tr>";
				 }
				 if(result.ContrastSummary.length>0){
					 txt+="<tr><td colspan=4><center><b>Contrast Summary</b></center></td></tr>";
					 for(i=0;i<result.ContrastSummary.length;i++)
					 {
						 	txt+="<tr><td>"+result.ContrastSummary[i].Product+"</td><td>"+result.ContrastSummary[i].Contrast+"</td><td>"
							+result.ContrastSummary[i].Fabric+"</td></tr>";
					 }
			 	 }
				 if(result.FabricSummary.length>0){
					 txt+="<tr><td colspan=4><center><b>Fabric Summary</b></center></td></tr>";
					 for(i=0;i<result.FabricSummary.length;i++)
					 {
						 	txt+="<tr><td>"+result.FabricSummary[i].Area+"</td><td>"+result.FabricSummary[i].Name+"</td><td>"
							+result.FabricSummary[i].Price+"</td></tr>";
					 }
				}
				if(result.MonogramSummary.length>0){
					 txt+="<tr><td colspan=4><center><b>Monogram Summary</b></center></td></tr>";
					 for(i=0;i<result.MonogramSummary.length;i++)
					 {
						 	txt+="<tr><td>"+result.MonogramSummary[i].MonogramPlacement+"</td><td>"+result.MonogramSummary[i].MonogramFont+"</td><td>"
							+result.MonogramSummary[i].MonogramColor+"</td></tr>";
					 }
				}
               	
               	if (localStorage.getItem("measurementObject") != null) 
                {
                  	 var measurement_array = JSON.parse(localStorage.getItem('measurementObject'));
                  
                  	 txt+="<tr><td colspan=4><center><b>Measurement Summary</b></center></td></tr>";
                  
					 for(i=0;i<measurement_array.length;i++)
					 {
						 	txt+="<tr><td>"+measurement_array[i].product+"</td><td>"+measurement_array[i].option+"</td><td>"
						+measurement_array[i].feature+"</td><td>"+measurement_array[i].price+"</td></tr>";
					 }
                }
               
				txt+="</table>"
				$("#sum").empty();
				$("#sum").append(txt);
               $("<div class='col-sm-6' style='display:none;'><form>Name:<br><input type='text' name='name' class='form-control'><br>Email:<br><input type='email' name='email' class='form-control'><br><input type='button' class='btn btn-primary' value='Send Mail'></form>").insertAfter("#sum table"); 
               	//<form>Name:<br><input type='text' name='name'><br>Email:<br><input type='email' name='email'><br><input type='submit' value='Send Mail'></form> 
				 //getsummary();
				$("#summaryModel").modal({
					keyboard : true,
					backdrop : "static"
				});

				$("#summaryModel .modal-dialog").css("width", "-moz-fit-content");
			 });
/*********************** Specific View ***************************************/
		 $(".zoom_garments_c").click(function(){
			 if(zoom==true){
				 $(this).removeClass("selected");
				 obj.SpecificRender(false);
				 zoom=false;
				 $(".loder").show();
			 }else{
				 $(this).addClass("selected");
				 obj.SpecificRender(true);
				 zoom=true;
				 $(".loder").show();
			 }
		 });
/*************************** Fabric Search ********************************/

/*********************** Alignment ***************************************/
		 $(".change-align_c").click(function(){
			 $(".loder").show();
		 });
/************************* Save Look *************************************/
		 $(".cardButton").click(function(){
			var look= obj.Look();
			var name=prompt("Enter Name For your Look");
			if(name != null){
				$.ajax({
				 url:"Code/mylook.php?savelook",
				 type:"POST",
				 //dataType : "json",
				 data:{
					 look : look.Data,
					 name : name,
					 image : look.Url,
					 product : product,
				 },
				}).done(function(r){
					 alert(r);
				}).fail(function(jqXhr, textStatus, errorThrown) {
					alert("Please Try Again");
				});
			}
		 });
/*********************** Save Image ***************************************/

		 $(".saveImage").click(function(){
			 var img=obj.Look();
			 window.open(img.Url,"_blank");
		 });
/******************** Share Button Event ************************************/
		 $(".shareButton").click(function(){
			 var img=obj.Look();
			 $("#link").attr("value",img.Url);
			 $("#share").modal({
		 		keyboard : true,
		 		backdrop : "static"
		 	});
		 });

		 $("#download").click(function(){
			 var img=obj.Look();
			 window.open(img.Image,"_blank");
		 });
/********************* Monogram Event ****************************************/
		 $("#pddd").on('click','#Monogram',function(){
			  $(".sub_tital").html($(this).find('span').html());
				hideDiv("color_sub_menu");
				hideDiv("fabric_sub_menu");
			 	showDiv('monogram_sub_menu');
		 });
		 $("#pftdd").on('click','span',function(e){
			e.stopPropagation();
			alert($(this).html());
		 });
/******************* Fabric Event *******************************************/
		  $("#pddd").on('click','#Fab',function(){
			 $("#query-text").val("");
			 if($(window).width()>1050)
			 {
				 $(".sub_tital").html($(this).find('span').html());
				 showDiv('fabric_sub_menu');
			 }
			 else {
				// getc(0,$("#pddd li").eq(1).attr("data-tds-product"));
				$("#pddd li").eq(1).addClass("abc");
			 	$(".menu4").addClass("show-nav");
			 }
		 });
/******************* Send Mail *******************************************/

		$("#send").on('click',function(){
			email = $("#usr").val();
			//console.log(email);
			sendEmail(email);
				
		});
		$("#usr").on('keypress',function(e){
			if (e.which == 13) {
				sendEmail($(this).val());
			}
		});
		function sendEmail(email){
			//swal('Please wait');
			//swal.showLoading();
			$('#share .loder').show();
			if(ValidateEmail(email)){
				var url = $("#link").val();
				$.ajax({
					url : "Code/mylook.php?sendMail",
					type : "POST",
					dataType : "json",
					data : {
						email : email,
						imageUrl : url
					}
				}).done(function(r){
					if(r.Status)
					{
						swal({showCloseButton:true,title:'Congratulations...',text:'Email send successfully',type:'success'});
						$("#usr").val("");
						$('#share .loder').hide();
					}else{
						$('#share .loder').hide();
						swal({showCloseButton:true,title:'Oops...',text:'Email not send, please try again..',type:'error'});
					}
				}).fail(function(jqXhr, textStatus, errorThrown) {
					$('#share .loder').hide();
					swal({showCloseButton:true,title:'Oops...',text:'Something Wrong Please try again..',type:'error'});
				});
			}
			else{
				console.log("false");
				$('#share .loder').hide();
				swal({showCloseButton:true,title:'Oops...',text:'Please Enter Valid Email Address..',type:'error'});
				$("#usr").val("");
			}
		}
		 /*$("#garments").click(function(){
			 if(lenszoom==false || lenszoom==undefined)
			 {
				 lenszoom=true
			 }
			 else {
			 	lenszoom=false;
			 }

			 if(lenszoom==true)
			 {
				 $("#zoom span").removeClass("zoom").addClass("zoomselected");
						var aa=$('#garments img:last').data('elevateZoom');
						aa.changeState('enable');
			 }
			 else {
			 	$("#zoom span").removeClass("zoomselected").addClass("zoom");
				var aa=$('#garments img:last').data('elevateZoom');
				aa.changeState('disable');
			 }
		 });
		 $("#garments").on('click','img',function(){
			 //alert("adfaf");
		 });*/

		 //setTimeout(function(){  getc(0,$("#pddd li").eq(1).attr("data-tds-product"));$("#pddd li").eq(1).addClass("abc") }, 300);
		 
/******************* Reset Event *******************************************/

	$("#resetProduct").click(function(){
		$(".loder").show();
		obj.ResetProduct();
	});
	$("#resetContrast").click(function(){
		$(".loder").show();
		obj.ResetContrast();
	});


/*********************** For Slider ***************************************/

		sliderIn();

/**************************** Get DropDown **********************************/
			//GetAllDropDown();
/************************ Set Look **************************************/
			/*var url = document.location.href;
			if(url.includes("?")==true){
				var params = url.split('?')[1].split('&'),
				data = {}, tmp;
				for (var i = 0, l = params.length; i < l; i++) {
				     tmp = params[i].split('=');
				     data[tmp[0]] = tmp[1];
				 }
				product=data.product;
				//obj.Product(data.product);
				setTimeout(function(){obj.Product(data.product);},1050);
				setTimeout(function(){obj.Look(data.name)},2000);
			}*/

/**************************************************************/
	if(sessionStorage.getItem('IsMesurmentOpen') != null)
	{
		openMesurement();
		sessionStorage.removeItem("IsMesurmentOpen");
	}
/**************************************************************/


		});
	/*********************** Fabric ***************************************/
	function fabricSearch(){
		$('#query-text').unbind("keypress");
		$("#getFabricPanelByText").unbind("click");
		$("#getFabricPanelByText").click(function(){
			//alert($(this).val());
			if($("#query-text").val() != "")
			{
				if($("#pddd li").hasClass("abc")){
				var id = $("#pddd .abc").attr("data-tds-product")+"/"+$("#query-text").val();
				console.log(id);
				getc(0,id);
				}else{
					console.log("Id Not Found");

				}

			}else{
				var id = $("#pddd .abc").attr("data-tds-product");
				getc(0,id);
			}

		});
		$('#query-text').keypress(function (e) {
		  if (e.which == 13) {
			// $('form#login').submit();
			if($("#query-text").val() != "")
			{
				if($("#pddd li").hasClass("abc")){
				var id = $("#pddd .abc").attr("data-tds-product")+"/"+$("#query-text").val();
				console.log(id);
				getc(0,id);
				}else{
					console.log("Id Not Found");

				}

			}else{
				var id = $("#pddd .abc").attr("data-tds-product");
				getc(0,id);
			}
			return false;    //<---- Add this line
		  }
		});
	}
	function contrastFabricSearch(){
		$('#query-text').unbind("keypress");
		$("#getFabricPanelByText").click(function(){
			if($("#query-text").val() != "")
			{
				//alert($(this).val());
				var id = $("#pddd .abc").attr("data-tds-product")+"/c/"+$("#query-text").val();
				console.log(id);
				getc(1,id);
			}else{
				var id = $("#pddd .abc").attr("data-tds-product");
				getc(1,id);
			}
		});
		$('#query-text').keypress(function (e) {
		  if (e.which == 13) {
			if($("#query-text").val() != "")
			{
				//alert($(this).val());
				var id = $("#pddd .abc").attr("data-tds-product")+"/c/"+$("#query-text").val();
				console.log(id);
				getc(1,id);
			}else{
				var id = $("#pddd .abc").attr("data-tds-product");
				getc(1,id);
			}
			return false;    //<---- Add this line
		  }
		});
	}
function getc(count,id,Libconfig) {
	var container="";
	
	if($(window).width()>1050)
	{
		container="#fabric_list";
		fabricSearch();
	}else if(count==2 || count==3)
	{
		container="#pfdd3";
		Fab = true;
		
	}else {
		container="#pfdd4";
	}
	
	if(count>0){
		if(Libconfig == undefined ){
			if (id.toString().indexOf("/c") == -1){id= id+"/c";}
			contrastFabricSearch();
			Fab = true;
		}
	}
	$(container).empty();
	$.getJSON({
			url: serviceUrl+"/v1/Swatches?key="+key+"&id="+id,
			success: function (data) {
				//console.log(data);
			$(container).empty();
			var t = 1000,s;
				for (var url in data) {
					s = "<li id="+data[url].Id+"><a href='#'><span class='fabric_image' style='background:url("+serviceUrl+"/v1/SwatchImage?key="+key+"&"+data[url].Id+");background-size:100% 100%'></span></a><div><label class='fabric_name'>"+data[url].Name+"</label></div></li>";
					//setF(s,t,container);
					//t += 500;
					$(container).append(s);
				}
			$(container+" li").click(function(){
			if(count == 3){
				$(".loder").show();
				obj.LibConfigTexture(this.id);
			}else if(count>0)
			{
				$(".loder").show();
				obj.ContrastTexture(this.id);
			}
			else {
				var fabricImage=$(this).find("span").css("background-image");
				$("#pddd #Fab a").css({"background-image":""+fabricImage+"","background-repeat":"no-repeat"});
				$(".loder").show();
			 obj.Texture(this.id);
			}

		});
	},
	error: function () {
		var txt = "<li style='float: left;width: 100%;margin: 0;margin-bottom: 25px;margin-top: 20%;margin-left: 25px;'><h4>No Record Found</h4></li>"
		$(container).empty();
		$(container).append(txt);
	}
});
}
function setF(s,t,c){
	setTimeout(function(){
		$(c).append(s);
	},t);
}
/************************* Summary *************************************/
function getsummary(){
	$("#summary-model").html();
	var canvas = document.getElementById('summary-image');
	var context = canvas.getContext('2d');
	var i = 0;
	var height = 0;
	var width = 0;

	var img = new Image();
	var src = $($("#garments").find("img")[1]).attr("src");
	if (src != undefined) {
		img.src = src;
		height = img.height;
		width = img.width;
	}

	$("#garments").find("img").each(function() {
		src = $(this).attr("src");
		if (src != "") {
			img = new Image();
			img.src = src;
			if (i == 0) {
				if (height == 0) {

					canvas.width = img.width;
					canvas.height = img.height;
					if (img.width == 1)
						i = -1;
				} else {
					canvas.width = width;
					canvas.height = height;
				}
			}
			//alert(img);
			context.drawImage(img, 0, 0, width, height);
		}

		i++;
	});
	$("#summaryModel").modal({
		keyboard : true,
		backdrop : "static"
	});

	$("#summaryModel .modal-dialog").css("width", "-moz-fit-content");
}
/************************ Slider Reload Function *****************************/
function sliderIn(){
	if ($(window).width() < 1050) {
		slider = $slider.bxSlider({
			mode : 'horizontal',
			minSlides : Math.floor($(".navbar.navbar-vertical-left")
					.width() / 120),
			/*minSlides:2,*/
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		slider1 = $slider1.bxSlider({
			mode : 'horizontal',
			minSlides : Math.floor($(".navbar.navbar-vertical-left")
					.width() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		slider2 = $slider2.bxSlider({
			mode : 'horizontal',
			minSlides : Math.floor($(".navbar.navbar-vertical-left")
					.width() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});
		slider3 = $slider3.bxSlider({
			mode : 'horizontal',
			minSlides : Math.floor($(".navbar.navbar-vertical-left")
					.width() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		slider4 = $slider4.bxSlider({
			mode : 'horizontal',
			minSlides : Math.floor($(".navbar.navbar-vertical-left")
					.width() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

	} else {
		slider = $slider.bxSlider({
			mode : 'vertical',
			minSlides : Math.floor($(".navbar.navbar-vertical-left")
					.height() / 140),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		slider1 = $slider1.bxSlider({
			mode : 'vertical',
			minSlides : Math.floor($(".navbar.navbar-vertical-left")
					.height() / 140),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true,
		});

		slider2 = $slider2.bxSlider({
			mode : 'vertical',
			minSlides : Math.floor($(".navbar.navbar-vertical-left")
					.height() / 140),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true,
		});
		slider3 = $slider3.bxSlider({
			mode : 'vertical',
			minSlides : Math.floor($(".navbar.navbar-vertical-left")
					.height() / 140),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true,
		});
		slider4 = $slider4.bxSlider({
			mode : 'vertical',
			minSlides : Math.floor($(".navbar.navbar-vertical-left")
					.height() / 140),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true,
		});

	}

	document.getElementById('pddd').addEventListener('mousewheel',
			mouseWheelEvent);
	document.getElementById('pddd').addEventListener('DOMMouseScroll',
			mouseWheelEvent);

	document.getElementById('pfdd').addEventListener('mousewheel',
			mouseWheelEvent1);
	document.getElementById('pfdd').addEventListener('DOMMouseScroll',
			mouseWheelEvent1);

	document.getElementById('pfdd2').addEventListener('mousewheel',
			mouseWheelEvent2);
	document.getElementById('pfdd2').addEventListener('DOMMouseScroll',
			mouseWheelEvent2);

	document.getElementById('pfdd3').addEventListener('mousewheel',
			mouseWheelEvent3);
	document.getElementById('pfdd3').addEventListener('DOMMouseScroll',
			mouseWheelEvent3);

	document.getElementById('pfdd4').addEventListener('mousewheel',
			mouseWheelEvent4);
	document.getElementById('pfdd4').addEventListener('DOMMouseScroll',
			mouseWheelEvent4);
}
function SliderReload() {
	if ($(window).width() < 1050) {
		$slider.reloadSlider({
			mode : 'horizontal',
			minSlides : Math
					.floor($(".navbar.navbar-vertical-left").width() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		$slider1.reloadSlider({
			mode : 'horizontal',
			minSlides : Math
					.floor($(".navbar.navbar-vertical-left").width() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		$slider2.reloadSlider({
			mode : 'horizontal',
			minSlides : Math
					.floor($(".navbar.navbar-vertical-left").width() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		$slider3.reloadSlider({
			mode : 'horizontal',
			minSlides : Math
					.floor($(".navbar.navbar-vertical-left").width() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		$slider4.reloadSlider({
			mode : 'horizontal',
			minSlides : Math
					.floor($(".navbar.navbar-vertical-left").width() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

	} else {
		$slider.reloadSlider({
			mode : 'vertical',
			minSlides : Math
					.floor($(".navbar.navbar-vertical-left").height() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		$slider1.reloadSlider({
			mode : 'vertical',
			minSlides : Math
					.floor($(".navbar.navbar-vertical-left").height() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		$slider2.reloadSlider({
			mode : 'vertical',
			minSlides : Math
					.floor($(".navbar.navbar-vertical-left").height() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		$slider3.reloadSlider({
			mode : 'vertical',
			minSlides : Math
					.floor($(".navbar.navbar-vertical-left").height() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

		$slider4.reloadSlider({
			mode : 'vertical',
			minSlides : Math
					.floor($(".navbar.navbar-vertical-left").height() / 120),
			moveSlides : 3,
			slideMargin : 10,
			infiniteLoop : false,
			adaptiveHeight : false,
			hideControlOnEnd : true
		});

	}

}
/************************** Slider Mouse Event *******************************/
function mouseWheelEvent(event) {
	var delta = event.wheelDelta ? event.wheelDelta : -event.detail;
	if (delta < 0) {
		slider.goToNextSlide();

	}
	if (delta > 0) {
		slider.goToPrevSlide();
	}
	event.stopPropagation();
	event.preventDefault();
}

function mouseWheelEvent1(event) {
	var delta = event.wheelDelta ? event.wheelDelta : -event.detail;
	if (delta < 0) {
		slider1.goToNextSlide();
	}
	if (delta > 0) {
		slider1.goToPrevSlide();
	}
	event.stopPropagation();
	event.preventDefault();
}
function mouseWheelEvent2(event) {
	var delta = event.wheelDelta ? event.wheelDelta : -event.detail;
	if (delta < 0) {
		slider2.goToNextSlide();
	}
	if (delta > 0) {
		slider2.goToPrevSlide();
	}
	event.stopPropagation();
	event.preventDefault();
}
function mouseWheelEvent3(event) {
	var delta = event.wheelDelta ? event.wheelDelta : -event.detail;
	if (delta < 0) {
		slider3.goToNextSlide();
	}
	if (delta > 0) {

		slider3.goToPrevSlide();
	}
	event.stopPropagation();
	event.preventDefault();
}
function mouseWheelEvent4(event) {
	var delta = event.wheelDelta ? event.wheelDelta : -event.detail;
	if (delta < 0) {
		slider4.goToNextSlide();
	}
	if (delta > 0) {
		slider4.goToPrevSlide();
	}
	event.stopPropagation();
	event.preventDefault();
}
/************************** Show/Hide Div ************************************/
function hideDiv(id,b) {
	if($("#pddd li").hasClass("active"))
	{
		$("#pddd li").removeClass("active");
	}
	var obj = document.getElementById(id);
	if (obj) {
		obj.style.display = 'none';
	}
	// if(b==true)
	// {
		// getc(0,$("#pddd li").eq(1).attr("data-tds-product"));
	// }
}

function showDiv(id) {
	var obj = document.getElementById(id);
	if (obj) {
		obj.style.display = 'block';
	}
}
/*************************** DropDown Function *******************************/
function GetAllDropDown() {

	$(".loder").show();
	$.ajax({
				url : serviceUrl+"/v1/product?key="+key,
				//url : "http://localhost:9090/TailoriService/rest/WEBAPI/product?Key=4101933343",
				type : "GET",
				dataType : "json",
			}).done(
					function(r) {
						var name;
						var dropDownHtmlmen=" <li class='dropdown'> "
								+ "<a  href='#' class='dropdown-toggle active' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>"
								+ "Men"
								+ " "
								+ "<span class='caret'></span></a>"
								+ "<ul id='"
								+ "Men"
								+ "' class='dropdown-menu'>";
						var dropDownHtmlwomen=" <li class='dropdown'> "
										+ "<a  href='#' class='dropdown-toggle active' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>"
										+ "Women"
										+ " "
										+ "<span class='caret'></span></a>"
										+ "<ul id='"
										+ "Product"
										+ "' class='dropdown-menu'>";
										var i=0;
										var info="";
						$.each(r,function(index,value) {

							if(index.toLowerCase().indexOf("women") > -1)
							{
								dropDownHtmlwomen += " <li id='"
											+ index
											+ "' hex='"+value+"'><a  href='#'>"
											+ index
											+ "</a></li>";

							}else{
								dropDownHtmlmen += " <li id='"
											+ index
											+ "' hex='"+value+"'><a  href='#'>"
											+ index
											+ "</a></li>";

							}
								});

						dropDownHtmlmen += "</ul></li>";
						dropDownHtmlwomen += "</ul></li>";
						$("#ptgdd").empty();
						$("#ptgdd").append(dropDownHtmlmen+dropDownHtmlwomen);
						//$("#ptgdd").append(dropDownHtmlmen);
						$("#Men li").eq(0).addClass("active");
						SetDropDownEvent();
						//obj.Product(info);

					}).fail(function(jqXhr, textStatus, errorThrown) {
					alert("Please Try Again Product");
					console.log("jqXhr : "+jqXhr);
					console.log("textStatus : "+textStatus);
					console.log("errorThrown : "+errorThrown);
			});
}
function SetDropDownEvent() {
	$("#ptgdd").on('click','.dropdown-menu li',function() {
		$(".in").removeClass("in");
		$(this).siblings().removeClass("active");
		$(this).addClass("active");
		//var info=$(this).parent().siblings().text().trim()+"-"+$(this).text().trim();
		var info=this.id;
		if($(this).parent().attr('id').toLowerCase() == "men")
			$("#Product li").removeClass('active');
		if($(this).parent().attr('id').toLowerCase() == 'product')
			$("#Men li").removeClass('active');
		$(".loder").show();
		obj.Product(info.toString());
		product=info.toString();

		//setTimeout(function(){  getc(0,$("#pddd li").eq(1).attr("data-tds-product"));$("#pddd li").eq(1).addClass("abc"); }, 2000);
		mono=true;
	});
}
function fg(){
	// var txt=$("#monogram-text").val();
	// $("#monogram-label").empty().html(txt);
}
function ValidateEmail(mail)   
{  
 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))  
  {  
    return (true)  
  }  
    //alert("You have entered an invalid email address!")  
    return (false)  
} 
/************************** End ************************************/
